module.exports = __webpack_public_path__ + "lp/img/logo_myStage-GR.36481e29.svg";